import type { ReactNode } from 'react';
import { QueryProvider } from './QueryProvider';
import { ThemeProvider } from './ThemeProvider';
import { AuthProvider } from '@/auth/AuthProvider';
import { ConfirmDialogHost } from '@/components/ui/confirm';
import { Toaster } from '@/components/ui/sonner';

/** Provider tree (doc 01 §4.9): QueryClient -> Theme -> Auth, plus the global confirm + toast hosts. */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <QueryProvider>
      <ThemeProvider>
        <AuthProvider>
          {children}
          <ConfirmDialogHost />
          <Toaster />
        </AuthProvider>
      </ThemeProvider>
    </QueryProvider>
  );
}
